import TrapFocus from '../utils/trap-focus';

/**
 * Manage mobile menu functionality
 *
 * @param {HTMLElement} el - The root element of the mobile menu.
 * @returns {void}
 */
class MobileMenu {
  constructor(el) {
    this.body = document.querySelector('body');
    this.toggleEl = el.querySelector('.js-mobile-menu-toggle');

    this.isOpenClass = 'mobile-menu-open';

    this.trapFocus = new TrapFocus(el, this.handleEscape.bind(this));
    this.bindEvents();
  }

  /**
   * Add event listeners
   *
   * @return {void}
   */
  bindEvents() {
    this.toggleEl.addEventListener('click', this.toggle.bind(this));
  }

  /**
   * Functionality to run with an escape keystoke
   *
   * @return {void}
   */
  handleEscape() {
    this.close();
    this.trapFocus.deactivate();
    this.toggleEl.focus();
  }

  /**
   * Toggle the mobile menu
   *
   * @return {void}
   */
  toggle() {
    if (this.body.classList.contains(this.isOpenClass)) {
      this.close();
      this.trapFocus.deactivate();
    } else {
      this.open();
      this.trapFocus.activate();
    }
  }

  /**
   * Open the mobile menu and update any state for the toggle
   *
   * @return {void}
   */
  open() {
    this.body.classList.add(this.isOpenClass);
    this.toggleEl.textContent = 'Close';
    this.toggleEl.setAttribute('aria-expanded', 'true');
  }

  /**
   * Close the mobile menu and update any state for the toggle
   *
   * @return {void}
   */
  close() {
    this.body.classList.remove(this.isOpenClass);
    this.toggleEl.textContent = 'Menu';
    this.toggleEl.setAttribute('aria-expanded', 'false');
  }
}

export default MobileMenu;
